// extracted by mini-css-extract-plugin
module.exports = {"imagePreview":"AutocompleteSearch_imagePreview__b7QV0","input":"AutocompleteSearch_input__10bhI"};